import {Component, HostListener, OnDestroy, OnInit} from "@angular/core";
import {Router} from "@angular/router";
import {HttpClient} from "@angular/common/http";
import {SpotifyTagsService} from "../../services/spotify-tags-service";
import {ExpandedFoldersService} from "../../services/expanded-folders-service";
import {Subscription} from "rxjs";

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit, OnDestroy {

  displayName: string;
  showExpandMenu = false;
  showSyncWithSpotify = false;
  showAlert = false;
  showTagsMenuOnMobile = false;
  showMobileMenu = false;
  alertSubscription: Subscription;
  navigationSubscription: Subscription;

  constructor(private http: HttpClient, public router: Router, private service: SpotifyTagsService, private expandedFoldersService: ExpandedFoldersService) {
  }

  ngOnInit() {
    this.showMobileMenu = window.innerWidth < 651;
    this.service.isAuthenticated().subscribe(res => {
      this.displayName = res.principal.attributes.display_name ? res.principal.attributes.display_name : res.principal.attributes.email;
    });
    this.initializeExpandedFolders();
    this.alertSubscription = this.service.alert$.subscribe(() => this.showAlert = true);
    this.navigationSubscription = this.service.navigation$.subscribe(() => this.showTagsMenuOnMobile = false);

  }

  ngOnDestroy() {
    this.alertSubscription.unsubscribe();
    this.navigationSubscription.unsubscribe();
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.showMobileMenu = window.innerWidth < 651;
  }

  initializeExpandedFolders() {
    if (!this.expandedFoldersService.getExpandedFolders()) {
      this.expandedFoldersService.setExpandedFolders([]);
    }
    if (!this.expandedFoldersService.getExpandArtists()) {
      this.expandedFoldersService.setExpandArtists(false);
    }
    if (!this.expandedFoldersService.getExpandAlbums()) {
      this.expandedFoldersService.setExpandAlbums(false);
    }
  }

  synchronise() {
    this.service.syncWithSpotify().subscribe(() => {
      this.showExpandMenu = false;
      this.showSyncWithSpotify = false;
      this.router.navigateByUrl('/');
    });
  }

  closeAlert() {
    this.showAlert = false;
  }

  toggleTagsMenu() {
    this.showTagsMenuOnMobile = !this.showTagsMenuOnMobile;
  }
}
